import { Localizer } from "infrastructure/localization/localizer";
import DynamicButton from "../button/dynamicButton";
import { CheckboxSwitch } from "../checkbox/checkboxSwitch";
import { ReactTooltip } from "../tooltips/ReactTooltip";
import { ForloebOverviewTypeEnum } from "core/sharedmodels/forloeb/forloebOverviewTypeEnum";
import useUser from "core/hooks/useUser";
import {ReactComponent as GearIcon} from "../../../content/icons/gear-solid.svg";

type ForloebOverviewSettingsButtonProps = {
  showHorizontaleLinjer: boolean;
  useOverlappendeVisning: boolean;
  showAnonymized: boolean;
  showInactive: boolean;
  showUnoccupiedStillinger: boolean;
  showForloebKladder: boolean;
  onShowHorizontaleLinjerChanged: (checked: boolean) => void;
  onUseOverlappendeVisningChanged: (checked: boolean) => void;
  onShowAnonymizedVisningChanged: (checked: boolean) => void;
  onShowInactiveStillingerChanged: (checked: boolean) => void;
  onShowUnoccupiedStillingerChanged: (checked: boolean) => void;
  onShowForloebKladderChanged: (checked: boolean) => void;

  forloebOverviewType: ForloebOverviewTypeEnum;
}

export const ForloebOverviewSettingsButton = ({
  showHorizontaleLinjer,
  useOverlappendeVisning,
  showAnonymized,
  showInactive,
  showUnoccupiedStillinger,
  showForloebKladder,
  onShowHorizontaleLinjerChanged,
  onUseOverlappendeVisningChanged,
  onShowAnonymizedVisningChanged,
  onShowInactiveStillingerChanged,
  onShowUnoccupiedStillingerChanged,
  onShowForloebKladderChanged,
  forloebOverviewType
}: ForloebOverviewSettingsButtonProps) => {

  const { currentUser } = useUser();

  return (
    <div className="margin-left-s">
      <DynamicButton id={"settings-icon-id"} rounded>
          <GearIcon />
      </DynamicButton>
      <ReactTooltip selectId={"settings-icon-id"} delay={100} place="left-start">
          <div className="flex-container-column ">
              <h4 className={"margin-bottom-s flex-start"}>{Localizer.forloebOverviewPage_forloebOverviewSettings()}</h4>
              <p className={"small flex-start margin-0"}>{Localizer.forloebOverviewPage_forloebOverviewSettingsDescription1()}</p>
              <p className={"small margin-bottom-m flex-start"}>{Localizer.forloebOverviewPage_forloebOverviewSettingsDescription2()}</p>
              <div className="border crop-container-border padding-s margin-bottom-s">
                  <div>
                      <CheckboxSwitch
                          id={"forloeboverview-horizontale-linjer-switch"}
                          defaultValue={showHorizontaleLinjer}
                          label={Localizer.forloebOverviewPage_visHorisontaleLinjer()}
                          reverseTextAndSwitch
                          onChange={(e) => onShowHorizontaleLinjerChanged(e.target.checked)}
                      />
                  </div>
                  <div className={"margin-top-s"}>
                      <CheckboxSwitch
                          id={"forloeboverview-overlap-switch"}
                          defaultValue={useOverlappendeVisning}
                          label={Localizer.visOverlappende()}
                          reverseTextAndSwitch
                          onChange={(e) => onUseOverlappendeVisningChanged(e.target.checked)}
                      />
                  </div>
                  {currentUser.IsAdminOrVus() && !(forloebOverviewType === ForloebOverviewTypeEnum.ForloebOverblikKladdeView) &&
                      <div className={"margin-top-s"}>
                          <CheckboxSwitch
                              id={"forloeboverview-anonymized-switch"}
                              label={Localizer.forloebOverviewPage_showAnonymizedForloeb()}
                              reverseTextAndSwitch
                              onChange={(e) => onShowAnonymizedVisningChanged(e.target.checked)}
                              defaultValue={showAnonymized}
                          />
                          
                      </div>
                  }
                  {currentUser.IsAdminOrVus() && (forloebOverviewType === ForloebOverviewTypeEnum.ForloebOverblikStillingerView) &&
                      <div className={"margin-top-s"}>
                          <CheckboxSwitch
                              id={"forloeboverview-inactive-switch"}
                              label={Localizer.forloebOverviewPage_showInactiveStillinger()}
                              reverseTextAndSwitch
                              onChange={(e) => onShowInactiveStillingerChanged(e.target.checked)}
                              defaultValue={showInactive}
                          />
                          
                      </div>
                  }
                  {forloebOverviewType === ForloebOverviewTypeEnum.ForloebOverblikStillingerView &&
                      <div className={"margin-top-s"}>
                          <CheckboxSwitch
                              id={"forloeboverview-showUnoccupied-switch"}
                              label={Localizer.global_unoccupied_stillinger()}
                              reverseTextAndSwitch
                              onChange={(e) => onShowUnoccupiedStillingerChanged(e.target.checked)}
                              defaultValue={showUnoccupiedStillinger}
                          />
                      </div>
                  }
                  {forloebOverviewType === ForloebOverviewTypeEnum.ForloebOverblikStillingerView &&
                      <div className={"margin-top-s"}>
                          <CheckboxSwitch
                              id={"forloeboverview-showForloebKladder-switch"}
                              label={Localizer.global_planlagteForloeb_stillinger()}
                              reverseTextAndSwitch
                              onChange={(e) => onShowForloebKladderChanged(e.target.checked)}
                              defaultValue={showForloebKladder}
                          />
                      </div>
                  }
              </div>
          </div>
      </ReactTooltip>
    </div>
  )
}
